import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "col-xs-12 col-md-6 text-center mb-4 search" }
const _hoisted_2 = {
  class: "card",
  style: {"height":"100%"}
}
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = { class: "card-title" }
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = { class: "text-justify" }
const _hoisted_9 = { class: "card-footer" }
const _hoisted_10 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512",
  "svg-inline": '',
  class: /*#__PURE__*/_normalizeClass('icon'),
  role: 'presentation',
  focusable: 'false',
  tabindex: '-1'
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("path", { d: "M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256 256-114.6 256-256S397.4 0 256 0zm0 464c-114.7 0-208-93.31-208-208S141.3 48 256 48s208 93.31 208 208-93.3 208-208 208zm40-128h-16v-88c0-13.2-10.7-24-24-24h-32c-13.2 0-24 10.8-24 24s10.8 24 24 24h8v64h-16c-13.2 0-24 10.8-24 24s10.8 24 24 24h80c13.25 0 24-10.75 24-24s-10.7-24-24-24zm-40-144c17.67 0 32-14.33 32-32s-14.33-32-32-32-32 14.3-32 32 14.3 32 32 32z" }, null, -1)
const _hoisted_12 = [
  _hoisted_11
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (!this.extension.legacyIcon)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: { name: 'Extension', params: { name: this.name } }
          }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                src: this.imageUrl,
                class: "card-img-top",
                alt: this.extension.name
              }, null, 8, _hoisted_3)
            ]),
            _: 1
          }, 8, ["to"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        (this.extension.legacyIcon)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              to: { name: 'Extension', params: { name: this.name } }
            }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  src: this.imageUrl,
                  alt: this.extension.name
                }, null, 8, _hoisted_5)
              ]),
              _: 1
            }, 8, ["to"]))
          : _createCommentVNode("", true),
        _createElementVNode("h3", _hoisted_6, _toDisplayString(this.extension.name), 1),
        _createElementVNode("p", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.extension.badges, (badge) => {
            return (_openBlock(), _createElementBlock("span", { key: badge }, [
              _createElementVNode("img", {
                src: this.badge(badge),
                alt: badge
              }, null, 8, _hoisted_7),
              _createTextVNode(" " + _toDisplayString(' '))
            ]))
          }), 128))
        ]),
        _createElementVNode("p", _hoisted_8, _toDisplayString(this.extension.intro), 1)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_router_link, {
          to: { name: 'Extension', params: { name: this.name } },
          class: "btn btn-success btn-lg"
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createElementBlock("svg", _hoisted_10, _hoisted_12)),
            _createTextVNode(" Read more… ")
          ]),
          _: 1
        }, 8, ["to"])
      ])
    ])
  ]))
}